/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class UserProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the user by ID
	 * @param {String|Number} pUserID - The user ID to search for
	 * @return {Promise<void>}
	 * @async
	 * @example
	 */
	getUserByID(pUserID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pUserID)
			{
				this.pict.log.error('No User ID provided.');
				return reject(new Error('No User ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`User/${pUserID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting User: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get users by a list of user IDs
	 * @param {Array<String|Number>} pUserList - The list of user IDs to search for
	 * @return {Promise<Array>} - A promise that resolves to an array of users
	 * @async
	 * @example
	 */
	getUsersByIDList(pUserList)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pUserList || !Array.isArray(pUserList) || pUserList.length === 0)
			{
				this.pict.log.error('No User List provided.');
				return reject(new Error('No User List provided.'));
			}

			this.pict.HeadlightRestClient.getJSON('Users/FilteredTo/FBL~IDUser~INN~' + pUserList.join(','), (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Users: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = UserProvider;
module.exports.default_configuration = {};
